import React, {useState, useEffect, useCallback, useRef} from 'react';
import styles from './CookieModal.module.scss'
import NavToggle from "components/icons/navToggle/NavToggle";
import {useDispatch, useSelector} from "react-redux";
import TagManager from 'react-gtm-module'
import ReactPixel from 'react-facebook-pixel';
import TwitterConvTrkr from "react-twitter-conversion-tracker";
import {buttonClick} from "utils/Helpers";

const CookieModal = (props) => {

    const accessible = useSelector(state => state.accessible);
    const dispatch = useDispatch()
    const [active, setActive] = useState(!accessible.cookiesAccepted);
    const [manageCookies, toggleManageCookies] = useState(false);
    const [analyticCookies, addAnalyticCookies] = useState(true);
    const [socialCookies, addSocialCookies] = useState(true);
    const [advertisingCookies, addAdvertisingCookies] = useState(true);
    const initialLoad = useRef(true);
    const prevCookieManage = useRef(false);
    const manageTitle = useRef();
    const accept = useRef();
    const reject = useRef();
    const info = useRef();

    const insertAnalyticCookies = useCallback(() => {

        let script = document.createElement('script');
        script.src = 'https://az725175.vo.msecnd.net/scripts/jsll-4.js';
        document.body.appendChild(script);

        script.onload = () => {

            let config = {
                autoCapture: {
                    lineage: true
                },
                coreData: {
                    appId: "js:surfaceobd"
                }
            };

            if(window.awa) {
                window.awa.init(config);
            }

        }

        const tagManagerArgs = {
            gtmId: 'GTM-WF4Z6WX'
        }

        TagManager.initialize(tagManagerArgs)


    }, [])

    const insertSocialCookies = useCallback(()=>{

        ReactPixel.init('1770559986549030');
        ReactPixel.pageView();

        TwitterConvTrkr.init("o4co9");
        TwitterConvTrkr.pageView();

    },[])

    const insertAdvertisingCookies = useCallback(()=>{
        const newImage = document.createElement('img');
        newImage.src = 'https://c.unsplash.com/c.gif?p=4468695';
        newImage.style.display = 'none';
        document.body.appendChild(newImage);
    },[])

    /** new user cookie selections **/
    useEffect(()=>{
        if(!initialLoad.current && localStorage.getItem('OBD_Analytic_Cookies') === 'true' && !active){
            insertAnalyticCookies();
        }
        if(!initialLoad.current && localStorage.getItem('OBD_Social_Cookies') === 'true' && !active){
            insertSocialCookies();
        }
        if(!initialLoad.current && localStorage.getItem('OBD_Advertising_Cookies') === 'true' && !active){
            insertAdvertisingCookies();
        }
        initialLoad.current = false;
    }, [active, analyticCookies, insertAnalyticCookies, socialCookies, insertSocialCookies,insertAdvertisingCookies]);


    /** previous cookie selection **/
    useEffect(()=>{
        if(localStorage.getItem('OBD_Analytic_Cookies') === 'true'){
            insertAnalyticCookies();
        }
        if(localStorage.getItem('OBD_Social_Cookies') === 'true'){
            insertSocialCookies();
        }
        if(localStorage.getItem('OBD_Advertising_Cookies') === 'true'){
            insertAdvertisingCookies();
        }
    }, [insertAnalyticCookies,insertSocialCookies,insertAdvertisingCookies]);



    function toggleManager(){
        prevCookieManage.current = true;
        toggleManageCookies(true)
        dispatch({ type: "SET_ACCESSIBLE",
            payload: {
                ...accessible,
                cookieModal: true
            }
        });
    }

    useEffect(()=>{
        setTimeout(()=>{
            if(active) info.current.focus()
        }, 100)

    }, [active])

    useEffect(()=>{
        if(!manageCookies && prevCookieManage.current) accept.current.focus();
        if(manageCookies){
            manageTitle.current.focus();
        }

    }, [manageCookies])


    function acceptCookies(){
        localStorage.setItem('OBD_Cookies', 'true');
        localStorage.setItem('OBD_Social_Cookies', socialCookies.toString());
        localStorage.setItem('OBD_Analytic_Cookies', analyticCookies.toString());
        localStorage.setItem('OBD_Advertising_Cookies', advertisingCookies.toString());
        dispatch({ type: "SET_ACCESSIBLE",
            payload: {
                ...accessible,
                cookiesAccepted: true,
                cookieModal: false
            }
        });
        setActive(false);

    }

    function rejectAllCookies(){
        localStorage.setItem('OBD_Cookies', 'true');
        localStorage.setItem('OBD_Social_Cookies', 'false');
        localStorage.setItem('OBD_Analytic_Cookies', 'false');
        localStorage.setItem('OBD_Advertising_Cookies', 'false');
        dispatch({ type: "SET_ACCESSIBLE",
            payload: {
                ...accessible,
                cookiesAccepted: true,
                cookieModal: false
            }
        });
        setActive(false);
    }

    function fetchCookieManager(){
        if(manageCookies){
            return (
                <div role={'dialog'} className={styles.managerBackground}>
                    <div className={styles.cookieModal}>
                        <div className={styles.header}>
                            <span ref={manageTitle} tabIndex={-1}>Manage cookie preferences</span>
                            <span tabIndex={0} role={'button'} onKeyDown={buttonClick} aria-label={'Close manage cookies modal'} className={styles.close} onClick={()=>toggleManageCookies(false)}>
                                <NavToggle menuOpen={true} closeOnly={true} dark={true}/>
                            </span>
                            <p>Most Microsoft websites use cookies. Cookies are small text files placed on your device to store data so web servers can use it later.
                                Microsoft and our third-party partners use cookies to remember your preferences and settings, help you sign in, show you personalized
                                ads, and analyze how well our websites are working. For more info, see the Cookies and similar technologies section of the
                                &nbsp;<a href={'https://go.microsoft.com/fwlink/?LinkId=521839 '} target={'_blank'} rel={'noreferrer'}>Privacy&nbsp;Statement</a>&nbsp;
                                <span className={styles.external}><img aria-hidden={true} src={'https://msobd-storage.azureedge.net/images/external-icon-black.png'} alt={'External link'}/></span> </p>
                        </div>
                        <div className={styles.preferences}>
                            <div>
                                <div className={styles.label}>Required </div>
                                <p>We use required cookies to perform essential website functions. For example, they're used to log you in, save your language preferences, provide a shopping cart experience, improve performance, route traffic between web servers, detect the size of your screen, determine page load times, improve user experience, and for audience measurement. These cookies are necessary for our websites to work. </p>
                            </div>
                            <div className={styles.checkRow}>
                                <div>
                                    <div className={styles.label}>Analytics</div>
                                    <p>We allow third parties to use analytics cookies to understand how you use our websites so we can make them better and the third parties can develop and improve their products, which they may use on websites that are not owned or operated by Microsoft. For example, they're used to gather information about the pages you visit and how many clicks you need to accomplish a task. We use some analytics cookies for advertising. </p>
                                </div>
                                <span tabIndex={0} aria-label={'Analytic Cookies'} role={'checkbox'} onKeyDown={buttonClick} aria-checked={analyticCookies} className={`${styles.checkBox} ${analyticCookies ? styles.white : styles.black}`} dangerouslySetInnerHTML={{__html:'&check;'}}
                                      onClick={()=>addAnalyticCookies(!analyticCookies)}/>

                            </div>
                            <div className={styles.checkRow}>
                                <div>
                                    <div className={styles.label}>Social Media</div>
                                    <p>We and third parties use social media cookies to show you ads and content based on your social media profiles and activity on our websites. They’re used to connect your activity on our websites to your social media profiles so the ads and content you see on our websites and on social media will better reflect your interests. </p>
                                </div>
                                <span tabIndex={0} aria-label={'Social Media Cookies'} role={'checkbox'} onKeyDown={buttonClick} aria-checked={socialCookies} className={`${styles.checkBox} ${socialCookies ? styles.white : styles.black}`} dangerouslySetInnerHTML={{__html:'&check;'}}
                                      onClick={()=>addSocialCookies(!socialCookies)}/>

                            </div>
                            <div className={styles.checkRow}>
                                <div>
                                    <div className={styles.label}>Advertising</div>
                                    <p>We and third parties use advertising cookies to show you new ads by recording which ads you've already seen. They're also used to track which ads you click on or purchases you make after clicking on an ad for payment purposes, and to show you ads that are more relevant to you. For example, they're used to detect when you click on an ad and show you ads based on your social media interests and website browsing history. </p>
                                </div>
                                <span tabIndex={0} aria-label={'Advertising Cookies'} role={'checkbox'} onKeyDown={buttonClick} aria-checked={advertisingCookies} className={`${styles.checkBox} ${advertisingCookies ? styles.white : styles.black}`} dangerouslySetInnerHTML={{__html:'&check;'}}
                                      onClick={()=>addAdvertisingCookies(!advertisingCookies)}/>

                            </div>
                        </div>
                        <div className={styles.footer}>
                            <div className={styles.links}>
                                <span>
                                    <a href={'https://go.microsoft.com/fwlink/?LinkId=521839 '} target={'_blank'} rel={'noreferrer'}>Privacy Statement</a>
                                    <img aria-hidden={true} src={'https://msobd-storage.azureedge.net/images/external-icon-black.png'} alt={'External link'}/>
                                </span>
                            </div>
                            <div tabIndex={0} role={'button'} onKeyDown={buttonClick} aria-label={'Accept preferences'} className={styles.submit} onClick={acceptCookies}>
                                Accept Preferences
                            </div>
                        </div>
                    </div>
                </div>
            )
        }
    }

    return active ? (
        <>
            <div aria-hidden={manageCookies} className={styles.cookieNotice}>
                <p tabIndex={-1} ref={info} id={'info'}>We use cookies to improve your experience on our websites and for advertising.&nbsp;<a href={'https://go.microsoft.com/fwlink/?LinkId=521839 '} target={'_blank'} rel={'noreferrer'}>Privacy&nbsp;Statement</a>&nbsp;
                    <span className={styles.external}><img aria-hidden={true} src={'https://msobd-storage.azureedge.net/images/external-icon-black.png'} alt={'External link'}/></span></p>
                <div>
                    <div tabIndex={0} role={'button'} onKeyDown={buttonClick} aria-label={'Accept Cookies'} aria-describedby={'info'}
                         ref={accept} className={styles.accept} onClick={acceptCookies}><span>Accept all</span></div>
                    <div tabIndex={0} role={'button'} onKeyDown={buttonClick} aria-label={'Reject Cookies'}
                         ref={reject} className={styles.accept} onClick={rejectAllCookies}><span>Reject</span></div>
                    <div tabIndex={0} role={'button'} onKeyDown={buttonClick} aria-label={'Manage Settings'}
                         className={styles.manage} onClick={toggleManager}>Manage cookies</div>
                </div>
            </div>
            {fetchCookieManager()}
        </>
    ) : '';
};

export default CookieModal
